
































































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { ProviderMatchService } from "@/service/provider-match.service";
import { ThankYouContent } from "@/models/content/thank-you";
import CommonMixin from "@/mixins/common-mixins";
import { AppData} from "@/models/app-data";
import { ProviderNotificationData } from "@/models/notification-data";
import VRuntimeTemplate from "v-runtime-template";
import { Vue } from 'vue-property-decorator';
import { CommonContent } from "@/models/content/common";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {
    VRuntimeTemplate,
    PageLoader
  }
})
export default class ThankYou extends Mixins(CommonMixin) {
  providerMatchService = new ProviderMatchService();
  content = {} as ThankYouContent;
  common = {} as CommonContent;
  appData = {} as AppData;
  textDirection = "ltr";
  pageLoaded = false;
  notificationData: Array<ProviderNotificationData> = [];
  numberOfMatches = 0;
  providerSentTemplate = "";
  savedId = "";
  providerList = null || "";

  async mounted(): Promise<void> {
    try {
      this.appData = this.getAppDataForPage();
      await this.loadContent();
      await this.LoadAndProcessSiteMatches();
      this.buildContentTemplate();
      this.pageLoaded = true;
      this.postNavigatedToParent();
    } catch (error) {
      this.showError(error);
    }
  }

  getAppDataForPage(): AppData {
      let appData = this.getAppData();

      if ( appData != null) {
        if ( appData.thankYouId == null) {
          const pageData = {} as AppData;
          pageData.thankYouId = appData.workflowId;
          pageData.applyGreatStart  = appData.applyGreatStart;
          pageData.applyHeadStart  = appData.applyHeadStart;
          
          this.savePageData(pageData);
          this.deleteAppData();
          appData = pageData;
        }
      } else {
        appData = this.getPageData();
      }

      return appData;
  }

  buildContentTemplate() {
    this.providerSentTemplate = `
            <span>
              ${this.content.ProviderSentMessage}
            </span>
      `;
  }

  async loadContent() {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getThankYouContent();
    this.common = await contentService.getCommonContent();
    this.textDirection = contentService.TextDirection();
    let programDesc = "";

    if (this.appData != null) {
      if (
        this.appData.applyHeadStart === true &&
        this.appData.applyGreatStart === true
      ) {
        programDesc = this.content.HeadStartAndGreatStart;
      } else if (this.appData.applyHeadStart === true) {
        programDesc = this.content.HeadStart;
      } else if (this.appData.applyGreatStart === true) {
        programDesc = this.content.GreatStart;
      }
      this.putWorkflowStep(this.appData.thankYouId, "ThankYou");
    }
    this.content.Header = this.content.Header.replace(
      "{programName}",
      programDesc
    );

  }

  async LoadAndProcessSiteMatches(): Promise<void> {
    this.notificationData = await this.providerMatchService.getNotificationData(this.appData.thankYouId);
    this.providerList = ''
    this.notificationData.forEach(p => {
      const agencyName = p.providerName
      p.sites.forEach(s => {

        let programDesc = ''
        const headstart = s.earlyheadstart || s.headstart;
        const greatstart = s.greatstart

        if (headstart && greatstart) {
            programDesc = `${this.common.HeadStartEarlyHeadStart}, ${this.common.GreatStartReadinessProgram}`;
        } else if (headstart) {
            programDesc = this.common.HeadStartEarlyHeadStart;
        } else if (greatstart) {
            programDesc = this.common.GreatStartReadinessProgram;
        }

        const siteRow =
        `<ul style="list-style-type:square">
          <li>
            <div>${agencyName}</div>
            <div>${s.site}</div>
            <div>${s.address}, ${s.city}, ${s.state} ${s.zip}</div>
            <div>${s.phone}</div>
            <div><b>${programDesc}</b></div>
          </li>
        </ul>`
        this.providerList += siteRow
      })
    })
    this.content.Line2 = this.content.Line2.replace(
      "{providerList}",
      this.providerList
    );
    let siteCount = 0;
    this.notificationData.forEach((p) => {
      // Add to the site count
      siteCount += p.sites.length;
    });

    this.numberOfMatches = siteCount

    this.content.Header = this.content.Header.replace(
      "{numberOfProviders}",
      this.numberOfMatches.toString()
    );
  }

  getPageData(): AppData {
    let appData!: AppData;

    if (Vue.$cookies != undefined) {
      appData = Vue.$cookies.get('thankYouappData') as AppData;
    }
    return appData;
  }

  savePageData(appData: AppData): void {
    if (Vue.$cookies != undefined) {
      Vue.$cookies.set('thankYouappData', appData);
    }
  }


}
